import React, { ReactElement } from 'react'
import { Center, Flex } from '@mantine/core'
import SignupForm from 'modules/Signup/Form'
import { NextPageWithLayout } from 'types/nextCustomType'
import { useAccountSourceTrack } from 'hooks'
import Footer from 'modules/Signup/Form/Footer'
import { SessionLayout } from 'components/site'
import { SessionPaper } from 'components/ui'
import useLoginActionStorage from 'hooks/useLoginActionStorage'
import { GetServerSideProps } from 'next'
import getT from 'next-translate/getT'
import { serverSideCheckLogin } from 'utils/serverSideAuthCheck'
import Head from 'next/head'

interface Props {
  referer?: string
}

const Signup: NextPageWithLayout<Props> = ({ referer }) => {
  useAccountSourceTrack(referer)
  useLoginActionStorage()

  return (
    <Flex className="h-full" direction="column">
      <Center className="flex-1">
        <SessionPaper noBorder minHeight={0} height="auto" p={40}>
          <SignupForm />
        </SessionPaper>
      </Center>
      <Footer />
    </Flex>
  )
}

Signup.getLayout = function getLayout(page: ReactElement) {
  return (
    <SessionLayout>
      <Head>
        <title>注册 - 浩客HowXm官网 - 数字化系统必备的应用内调研、评价、通知工具，支持免费试用</title>
      </Head>
      {page}
    </SessionLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale, req } = context
  const t = await getT(locale, 'pageSignup')
  const referer = req?.headers.referer || null
  return (
    serverSideCheckLogin(context) || {
      props: {
        pageTitle: t('pageSignup:title'),
        referer,
      },
    }
  )
}

export default Signup
